import * as React from 'react';
import { Box, Grid, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CurrencyObject } from 'common/types';
import { getPricingString } from 'common/utils/common';

interface Props {
	label: string;
	value: number;
	currency: CurrencyObject | undefined;
	bold?: boolean;
	variant?: 'body1' | 'body2' | 'caption' | 'h6';
	color?: 'primary' | 'secondary';
	py?: number;
	pt?: number;
	pb?: number;
	textClass?: string;
}

export const PricingRow = (props: Props) => {
	const {
		label,
		value,
		currency,
		bold = false,
		variant = 'body2',
		py,
		pt,
		pb,
		color = 'primary',
		textClass,
	} = props;
	const classes = useStyles();
	return (
		<Box pt={pt} pb={pb} py={py}>
			<Grid
				container
				spacing={0}
				alignContent="space-between"
				alignItems="flex-start"
				justifyContent="space-between"
			>
				<Grid>
					<Typography
						variant={variant}
						color={color === 'primary' ? 'textPrimary' : 'textSecondary'}
						className={textClass ? textClass : bold ? classes.boldText : classes.normalText}
					>
						{label}
					</Typography>
				</Grid>
				<Grid>
					<Typography
						variant={variant}
						color={color === 'primary' ? 'textPrimary' : 'textSecondary'}
						className={textClass ? textClass : bold ? classes.boldText : classes.normalText}
					>
						{getPricingString(value, currency)}
					</Typography>
				</Grid>
			</Grid>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		boldText: {
			fontWeight: 500,
		},
		normalText: {
			fontWeight: 400,
		},
	}),
);
